import { createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      orange: string;
    };
  }
  interface PaletteOptions {
    custom: {
      orange: string;
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C3E50',
    },
    secondary: {
      main: '#34495E',
    },
    custom: {
      orange: orange[800],
    },
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: '#2C3E50',
          borderRadius: '4px',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: orange[800],
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: orange[900],
          },
        },
      },
    },
  },
});

export default theme; 